export default __webpack_public_path__ + "static/media/pinkzebra2020.c7dd98a1.mp4";